import { DeleteElementOutDto, DeleteElementInDto } from '../../../types/element.dto'

export const DELETE_ELEMENT = 'DELETE_ELEMENT'
export const DELETE_ELEMENT_SUCCESS = 'DELETE_ELEMENT_SUCCESS'
export const DELETE_ELEMENT_ERROR = 'DELETE_ELEMENT_ERROR'
export const RESET_DELETE_ELEMENT = 'RESET_DELETE_ELEMENT'

export interface DeleteElement {
  type: typeof DELETE_ELEMENT
  payload: DeleteElementOutDto
}

export interface DeleteElementSuccess {
  type: typeof DELETE_ELEMENT_SUCCESS
  payload: DeleteElementInDto
}

export interface DeleteElementError {
  type: typeof DELETE_ELEMENT_ERROR
  payload: string | boolean
}

export interface ResetDeleteElement {
  type: typeof RESET_DELETE_ELEMENT
  payload: null
}

export interface State {
  data: DeleteElementInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

// Define una función que acepte un parámetro T y devuelva un initialState con ese tipo T
const createInitialState = (): State => {
  return {
    data: null,
    states: {
      loading: false,
      success: false,
      error: false,
    },
  };
};

// Ahora puedes usar esta función para inicializar el estado con el tipo T que necesites
export const initialState = createInitialState();

export type Actions = DeleteElement | DeleteElementSuccess | DeleteElementError | ResetDeleteElement
